"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnvironment = void 0;
const stage_types_1 = require("./stage_types");
/**
 * @deprecated Use isStage instead.
 */
const isEnvironment = (v) => stage_types_1.isStage(v);
exports.isEnvironment = isEnvironment;
//# sourceMappingURL=deprecated_environment_types.js.map